export const summaryRows: Array<[string, boolean, string, string]> = [
  ['150 casos clínicos resueltos', true, 'Incluido', 'Incluido'],
  ['Banco completo de evaluaciones', true, 'Incluido', 'Incluido'],
  ['Kit docente editable completo', true, 'Incluido', 'Incluido'],
  ['Banco de fichas técnicas del instrumental', true, 'Incluido', 'Incluido'],
  ['Cirugía de alta complejidad', false, 'No incluido', 'Robótica, trasplante, HIPEC, sala híbrida y TAVI'],
  ['Biblioteca de referencia profesional', false, 'No incluido', 'Atlas anatómico, farmacología, anestesiología y diccionario'],
  ['Normas internacionales AORN / ISO / JCI', false, 'No incluido', 'Estándares completos actualizados 2026'],
  ['Indicadores de calidad quirúrgica', false, 'No incluido', 'Métricas, ciclo PDCA y gestión del área quirúrgica'],
  ['Catálogo de implantes y trazabilidad', false, 'No incluido', 'Catálogo completo con normativa ANMAT 2026'],
];
